import {
  AppCategory,
  AppRecord,
  AppScreenModes,
} from '$tablet-app/src/app/app_library/types';
import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { openMainSystemSettings } from '$tablet-app/src/app/settings/functions';
import VideoAnchor from '$tablet-app/src/app/videos/components/VideoAnchor/VideoAnchor';
import { VideoTutorialLocation } from '@akin-home/video-tutorials';
import React, { FC } from 'react';
import styled from 'styled-components/native';
import MyApps from '../MyApps';

interface Props {
  apps: AppRecord[];

  uninstalled_apps?: AppRecord[];

  mode: AppScreenModes;

  search_text?: string;

  categories?: AppCategory[];

  category_filters?: string[];

  isLoading?: boolean;
  isRefetching?: boolean;

  onPressApp?: (app: AppRecord) => void;

  onPressLibraryApp?: (app: AppRecord) => void;

  onPressInstallApp?: () => void;

  onPressUninstall?: (app: AppRecord) => void;

  onChangeSearchText?: (text: string) => void;

  onPressCategoryFilter?: (category?: string) => void;

  onChangeMode?: (mode: AppScreenModes) => void;

  onPressSuggestAnApp: () => void;

  refresh?: () => void;
}

const empty_categories: string[] = [];
const empty_category_options: AppCategory[] = [];

const AppSelectionScreenView: FC<Props> = (props) => {
  const {
    apps,
    search_text,
    categories = empty_category_options,
    category_filters = empty_categories,
    isLoading,
    isRefetching,
    refresh,
    onChangeSearchText,
    onPressInstallApp,
    onPressApp,
    onPressUninstall,
    onPressCategoryFilter,
    onPressSuggestAnApp,
  } = props;

  return (
    <Container source={require('./app_screen_background.png')}>
      <SwitchContainer>
        <TopLeftButtons>
          <VideoAnchor location={VideoTutorialLocation.APPS}>
            {({ showVideo }) => (
              <NewButton
                variant="text"
                iconColor="white"
                onPress={showVideo}
                icon="question-circle"
              />
            )}
          </VideoAnchor>

          <NewButton
            variant="text"
            icon="rotate"
            iconColor="white"
            onPress={refresh}
          />

          <NewButton
            variant="text"
            iconColor="white"
            onPress={openMainSystemSettings}
            icon="cog"
          />
        </TopLeftButtons>

        <Title variant="h1" weight="semibold">
          My Apps
        </Title>

        <Row flex={1} justifyContent="flex-end">
          <NewButton icon="download" onPress={onPressInstallApp}>
            Download an app
          </NewButton>

          <Spacer width="16px" />

          <NewButton icon="comment-lines" onPress={onPressSuggestAnApp}>
            Suggest an app
          </NewButton>
        </Row>
      </SwitchContainer>

      <MyApps
        apps={apps}
        search_text={search_text}
        categories={categories}
        category_filters={category_filters}
        isLoading={isLoading}
        isRefetching={isRefetching}
        onChangeSearchText={onChangeSearchText}
        onPressApp={onPressApp}
        onPressCategoryFilter={onPressCategoryFilter}
        onPressUninstall={onPressUninstall}
        refresh={refresh}
      />
    </Container>
  );
};

const Container = styled.ImageBackground`
  flex: 1;

  padding: 30px 50px 0;

  background-color: #00e0ff;
`;

const SwitchContainer = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
`;

const Title = styled(Text)`
  color: white;
`;

const TopLeftButtons = styled.View`
  flex: 1;
  align-items: center;
  gap: 16px;
`;

export default AppSelectionScreenView;
